module.exports = __webpack_public_path__ + "img/carSecondLicense.685da02a.png";